import React, { useEffect, useState } from "react";
import { BsFillCalendar2DateFill } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { server, truncateText } from "../../common";
import { Col, Modal, Row } from "react-bootstrap";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import Textarea from "@mui/joy/Textarea";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../store/stateFunctions";
import displayRazorpay from "../../paymentmodule/Razorpay";
import { PAYMENT_KEY } from "../../config";
import { FcCalendar, FcClock } from "react-icons/fc";
import ShareModal from "../../ShareModal";
import { IoMdShare } from "react-icons/io";

const initialValues = {
  org_type: "",
  name: "",
  address: "",
  email: "",
  contactno: "",
  taluka: "",
  state: "",
  district: "",
  age: "",
  gender: "",
  user_count: "",
};

const AdminEventDetail = () => {
  const { id } = useParams();
  const user = useSelectAccess("Student");
  const [event, setEvent] = useState(null);
  const [data, setData] = useState([]);
  const [eventregistration, setEventRegistration] = useState(null);
  const [show, setShow] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharedUrl, setSharedUrl] = useState("");
  const [sharedTitle, setSharedTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const closeModal = () => setShow(false);

  // Function to open the Share modal
  const openShareModal = (url, title) => {
    setSharedUrl(sharedTitle);
    setSharedTitle(title);
    setShowShareModal(true);
  };

  // Function to close the Share modal
  const closeShareModal = () => {
    setShowShareModal(false);
  };
  const [step, setStep] = useState(1);
  const [user1, setUser1] = useState(null);
  const [payment, setPayment] = useState({});
  const isLoggedIn = user && user;
  const navigate = useNavigate();

  const handleNext = (data) => {
    setStep(step + 1);
    if (step === 1) {
      setUser1(data);
    } else if (step === 2) {
      setPayment(data);
    }
  };

  const handleOpen = () => {
    if (isLoggedIn) {
      setShow(true);
    } else {
      toast.info("Please log in to apply for the Event");
      navigate("/loginstudent"); // Assuming you have a "/login" route
    }
  };

  useEffect(() => {
    console.log(id);
    getevents();
    geteventRegistration();
    getData();
  }, [id]);

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      org_type: Yup.string().required("Select applicant type"),
      name: Yup.string().required("Please enter Full name"),
      address: Yup.string().required("Please Enter Full address"),
      email: Yup.string().required("Please enter Email id"),
      contactno: Yup.string().required("Please Contact No."),
      taluka: Yup.string().required("Please enter Taluka name"),
      state: Yup.string().required("Please enter State name"),
      district: Yup.string().required("Please enter District name"),
      age: Yup.string().required("Please enter Age"),
      gender: Yup.string().required("Please Select your Gender"),
      user_count: Yup.string().required("Please Enter Your Message"),
    }),

    onSubmit: (values, action) => {
      console.log(values);

      // if (!values.images) {
      //   toast.error("Please select a Resume");
      //   return;
      // }
      // const formData = new FormData();
      // formData.append("letter_description", values.letter_description);
      // formData.append("availability", values.availability);
      // formData.append("images", values.images);

      server
        .post(`/event/eventregistration/${event.id}`, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success(
                "Registration successfully completed please proceed for payment to confirm."
              );
              resetForm();
              handleNext();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  // yuvasarathi
  const getevents = () => {
    server
      .get(`/event/getevent/${id}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEvent(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // yuvasarathi
  const geteventRegistration = () => {
    server
      .get(`/event/geteventregistration`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEventRegistration(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Update Status
  const RazorpayPayment = async () => {
    const data = await fetch(
      `http://localhost:7001/api/event/proceedtocheckout/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: user.authToken,
        },
      }
    ).then((t) => t.json());

    console.log(data);

    //options
    const options = {
      key: PAYMENT_KEY,
      currency: data.currency,
      amount: data.amount,
      description: "wallet transaction",
      Image: "http://localhost:7001/logo_jpeg",
      order_id: data.id,
      // handler: toast.success("Payment Done"),
      handler: function (response) {
        alert("PAYMENT ID:" + response.razorpay_payment_id);
        alert("ORDER ID:" + response.razorpay_order_id);
        toast.success("Payment Done");
        setShow(false);
      },
      prefill: {
        //fill out the detail
        name: "Gauri",
        email: "gauri@gmail.com",
        contact: "9322695526",
      },
    };
    // setPaymentCompleted(true);
    //display the window on button click
    const paymentObject = new window.Razorpay(options);

    paymentObject.open();
  };

  const getData = () => {
    server
      .get("/event/getallevent", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  if (!event) {
    return (
      <div>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div style={{ marginTop: "1rem" }}>
        <div className="container-xl ">
          <div className="row p-2 rounded-2">
            <div className="col-md-8 shadow">
              <div className="my-3">
                <div className="row">
                  <div className="col-md-8">
                    <h3 className="p-2">DISCOVER EVENTS </h3>
                  </div>
                  <div className="col-md-4 text-end">
                    <p className="text-end fs-3">
                      <IoMdShare onClick={() => openShareModal(event.title)} />
                    </p>
                  </div>
                </div>
                <div id="carouselExampleIndicators" className="carousel slide">
                  <div className="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="0"
                      className="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="2"
                      aria-label="Slide 3"
                    ></button>
                  </div>
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        className="rounded-4 img-fluid"
                        src={event.image}
                        alt=""
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        className="rounded-4 img-fluid"
                        src={event.image}
                        alt=""
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        className="rounded-4 img-fluid"
                        src={event.image}
                        alt=""
                      />
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>

                <p className="my-3">
                  <h4>{event.title}</h4>
                  <b>Event Description :</b>
                  {event.description}
                </p>
                <p>
                  <b>Category </b>: {event.category}
                </p>

                <p>
                  <FcCalendar className="fs-3 me-3" />
                  <b>Date : </b> {event.event_date}
                </p>
                <p>
                  <CiLocationOn className="fs-3 me-3" />
                  <b>Venue : </b>
                  {event.address}
                </p>

                <p>
                  <FcClock className="fs-3 me-3" />
                  <b>Time : </b> {event.time}
                </p>
                <p>
                  <b>Google Map Location : </b>
                  <a href={event.location} target="_black">
                    View Location
                  </a>
                </p>

                <p>
                  <b>Fees:</b> {event.registration_fees}
                </p>
                <div className="text-center">
                  <button
                    className="btn rounded-4 banner w-50 text-white rounded-5"
                    onClick={handleOpen}
                  >
                    Register
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="shadow p-3">
                <h5>RELATED EVENTS</h5>
                {data.slice(0, 4).map((item) => (
                  <div key={item.id} className="py-3">
                    <div className="card-style rounded-top-5">
                      <div className="row">
                        <div className="col-md-4">
                          <img
                            src={item.image}
                            alt=""
                            className="card-img-top border border-1 p-1"
                          />
                        </div>
                        <div className="col-md-8">
                          <NavLink to={`/adminevents/${item.id}`} className="">
                            {item.title}
                          </NavLink>
                          <p>
                            <FcCalendar className="fs-3 me-3" />
                            <b></b> {item.event_date}
                          </p>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Modal show={show} onHide={closeModal} size="lg">
          <Modal.Header className="bg-light" closeButton>
            <Modal.Title>
              <h5>Event Registration Form </h5>
              <p></p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {step === 1 && (
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <Row>
                      <Col>
                        <div>
                          <TextField
                            name="name"
                            type="text"
                            margin="dense"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Enter Full Name"
                            variant="outlined"
                            label="Full Name"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.name}</p>
                        </div>
                        <div className="mt-2 mb-1">
                          <FormControl fullWidth required>
                            <InputLabel id="demo-simple-select-label">
                              Gender
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="category"
                              variant="outlined"
                              name="gender"
                              value={values.gender}
                              onChange={handleChange}
                              required
                            >
                              <MenuItem value="male">Male</MenuItem>
                              <MenuItem value="female">Female</MenuItem>
                              <MenuItem value="other">Other</MenuItem>
                            </Select>
                          </FormControl>
                          <p className="text-danger">{errors.gender}</p>
                        </div>
                        <div>
                          <TextField
                            name="contactno"
                            type="text"
                            margin="dense"
                            value={values.contactno}
                            onChange={handleChange}
                            placeholder="Enter Contact Number"
                            variant="outlined"
                            label="Contact Number"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.contactno}</p>
                        </div>
                        <div>
                          <TextField
                            name="address"
                            type="text"
                            margin="dense"
                            value={values.address}
                            onChange={handleChange}
                            placeholder="Enter Your Address"
                            variant="outlined"
                            label="Address"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.address}</p>
                        </div>
                        <div>
                          <TextField
                            name="taluka"
                            type="text"
                            margin="dense"
                            value={values.taluka}
                            onChange={handleChange}
                            placeholder="Enter Your Taluka Name"
                            variant="outlined"
                            label="Taluka Name"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.taluka}</p>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <TextField
                            name="email"
                            type="email"
                            margin="dense"
                            value={values.email}
                            onChange={handleChange}
                            placeholder="Enter Your Email Id"
                            variant="outlined"
                            label="Email Id"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.email}</p>
                        </div>
                        <div className="mt-2 mb-1">
                          <FormControl fullWidth required>
                            <InputLabel id="demo-simple-select-label">
                              Applicant Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="category"
                              variant="outlined"
                              name="org_type"
                              value={values.org_type}
                              onChange={handleChange}
                              required
                            >
                              <MenuItem value="student">Student</MenuItem>
                              <MenuItem value="employee">Employee</MenuItem>
                              <MenuItem value="businessowner">
                                Business Owner
                              </MenuItem>
                              <MenuItem value="other">Other</MenuItem>
                            </Select>
                          </FormControl>
                          <p className="text-danger">{errors.org_type}</p>
                        </div>
                        <div>
                          <TextField
                            name="age"
                            type="text"
                            margin="dense"
                            value={values.age}
                            onChange={handleChange}
                            placeholder="Enter Your Age"
                            variant="outlined"
                            label="Age"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.age}</p>
                        </div>
                        <div>
                          <TextField
                            name="state"
                            type="text"
                            margin="dense"
                            value={values.state}
                            onChange={handleChange}
                            placeholder="Enter Your State Name"
                            variant="outlined"
                            label="State Name"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.state}</p>
                        </div>
                        <div>
                          <TextField
                            name="district"
                            type="text"
                            margin="dense"
                            value={values.district}
                            onChange={handleChange}
                            placeholder="Enter Your District Name"
                            variant="outlined"
                            label="District Name"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{errors.district}</p>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div>
                    <TextField
                      name="user_count"
                      type="number"
                      margin="dense"
                      value={values.user_count}
                      onChange={handleChange}
                      placeholder="Enter Your Number Of Ticket"
                      variant="outlined"
                      label="Enter Number Of Ticket"
                      fullWidth
                      required
                    ></TextField>
                    <p className="text-danger">{errors.user_count}</p>
                  </div>

                  <span className="mb-1 d-block">
                    <input type="checkbox" name="" id="" /> &nbsp;I Agree, All
                    The
                    <b> Terms and Conditions</b> and Above Information is
                    Correct and If It Is Wrong Then I Am Responsible For The
                    Same.
                  </span>
                  <button className="my-2 banner text-white rounded-3 p-2 border-0">
                    Register
                  </button>
                  <button
                    className="my-2 banner text-white rounded-3 p-2 border-0"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </form>
              </div>
            )}
            {step === 2 && (
              <div>
                <div className="event-ticket">
                  <div className="row">
                    <div className="col">
                      <img
                        src="https://www.oyorooms.com/blog/wp-content/uploads/2018/02/type-of-event.jpg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="col ticket-header align-self-center">
                      <h2>{event.title}</h2>
                      <p>
                        <b>Date</b> | {event.event_date}
                      </p>
                      <p>
                        <b>Venue</b> | {event.address}
                      </p>
                      <p>
                        <b>Time </b> | {event.time}
                      </p>

                      <div className="ticket-details">
                        <h3>Ticket Details</h3>
                        <p>
                          <strong>Name:</strong> {eventregistration.name}
                        </p>
                        <p>
                          <strong>Email:</strong> {eventregistration.email}
                        </p>
                        <p>
                          <strong>Contact Number: </strong>
                          {eventregistration.contactno}
                        </p>
                        <p>
                          <strong>No Of Ticket count: </strong>
                          {eventregistration.user_count}
                        </p>
                        <p>
                          <b>Registration Fees: </b> | ₹
                          {eventregistration.registration_fee}
                        </p>
                        <p>
                          <b>Total Fees: </b> | ₹{eventregistration.totalFee}
                        </p>
                        {/* Add other ticket details */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <button
                onClick={handlePrevious}
                className="my-2 banner text-white rounded-3 p-2 border-0"
              >
                Previous
              </button> */}
                <button
                  className="my-2 banner text-white rounded-3 p-2 border-0 ms-2"
                  onClick={RazorpayPayment}
                >
                  Pay
                </button>
              </div>
            )}

            {/* <form>
            <div className="mb-2">
              <Row>
                <Col>
                  <div>
                    <TextField
                      name="name"
                      type="text"
                      margin="dense"
                      value={data.name}
                      placeholder="Enter Full Name"
                      variant="outlined"
                      label="Full Name"
                      fullWidth
                      required
                    ></TextField>
                  </div>

                  <div>
                    <TextField
                      name="contactno"
                      type="text"
                      margin="dense"
                      value={data.contactno}
                      placeholder="Enter Contact Number"
                      variant="outlined"
                      label="Contact Number"
                      fullWidth
                      required
                    ></TextField>
                  </div>

                  <div>
                    <TextField
                      name="taluka"
                      type="text"
                      margin="dense"
                      value={data.taluka}
                      placeholder="Enter Your Taluka Name"
                      variant="outlined"
                      label="Taluka Name"
                      fullWidth
                      required
                    ></TextField>
                  </div>

                  <div>
                    <TextField
                      name="state"
                      type="text"
                      margin="dense"
                      value={data.state}
                      placeholder="State"
                      variant="outlined"
                      label="State"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div>
                    <TextField
                      name="year"
                      type="text"
                      margin="dense"
                      value={data.year}
                      placeholder="Year"
                      variant="outlined"
                      label="Year"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                </Col>
                <Col>
                  <div>
                    <TextField
                      name="email"
                      type="email"
                      margin="dense"
                      value={data.email}
                      placeholder="Enter Your Email Id"
                      variant="outlined"
                      label="Email Id"
                      fullWidth
                      required
                    ></TextField>
                  </div>

                  <div>
                    <TextField
                      name="state"
                      type="text"
                      margin="dense"
                      value={data.state}
                      placeholder="Enter Your State Name"
                      variant="outlined"
                      label="State Name"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div>
                    <TextField
                      name="district"
                      type="text"
                      margin="dense"
                      value={data.district}
                      placeholder="Enter Your District Name"
                      variant="outlined"
                      label="District Name"
                      fullWidth
                      required
                    ></TextField>
                  </div>

                  <div>
                    <TextField
                      name="education"
                      type="text"
                      margin="dense"
                      value={data.education}
                      placeholder="Education"
                      variant="outlined"
                      label="Education"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div>
                    <TextField
                      name="college_name"
                      type="text"
                      margin="dense"
                      value={data.college_name}
                      placeholder="College Name"
                      variant="outlined"
                      label="College Name"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                </Col>
              </Row>
            </div>

            <span className="mb-1 d-block">
              <input type="checkbox" name="" id="" /> &nbsp;I Agree, All The
              <b> Terms and Conditions</b> and Above Information is Correct and
              If It Is Wrong Then I Am Responsible For The Same.
            </span>
            <div className="text-center">
              <button
                type="submit"
                className="my-2 banner text-white rounded-3 p-2 border-0"
                onClick={payment}
              >
                Procced for Payment
              </button>
            </div>
          </form> */}
          </Modal.Body>
        </Modal>
      </div>{" "}
      <ShareModal
        showModal={showShareModal}
        handleClose={closeShareModal}
        url={`https://yuvasarathi.com/#/adminevents/${id}`}
        title={sharedTitle}
      />
    </>
  );
};

export default AdminEventDetail;
